//@flow
import env from '../../../environment';
import {
  postCreator,
  getCreator,
  putCreator,
  deleteCreator,
} from '../../../http';

export const endpoints = Object.freeze({
  GET_MULTICHAT_FUNNELS: `${env.baseApiUrl}/im/admin/funnel`,
  GET_MULTICHAT_FUNNEL: `${env.baseApiUrl}/im/admin/funnel/:funnelId`,
  CREATE_MULTICHAT_FUNNEL: `${env.baseApiUrl}/im/admin/funnel`,
  EDIT_MULTICHAT_FUNNEL: `${env.baseApiUrl}/im/admin/funnel/:funnelId`,

  GET_MULTICHAT_FUNNEL_STAGES: `${env.baseApiUrl}/im/admin/funnel/stage`,
  GET_MULTICHAT_FUNNEL_STAGE: `${env.baseApiUrl}/im/admin/funnel/stage/:stageId`,
  CREATE_MULTICHAT_FUNNEL_STAGE: `${env.baseApiUrl}/im/admin/funnel/stage`,
  EDIT_MULTICHAT_FUNNEL_STAGE: `${env.baseApiUrl}/im/admin/funnel/stage/:stageId`,
  SORT_FUNNEL_CONVERSATIONS: `${env.baseApiUrl}/im/admin/funnel/:funnelId/conversations/sort`,

  SET_MULTICHAT_FUNNEL_MAIN_LANE: `${env.baseApiUrl}/im/admin/funnel/setting`,

  GET_LANE_CONVERSATIONS: `${env.baseApiUrl}/im/admin/funnel/:funnelId/:laneId/conversations`,
  DELETE_MULTICHAT_FUNNEL_LANE: `${env.baseApiUrl}/im/admin/funnel/lane/:laneId`,

  ADD_CONVERSATION_TO_FUNNEL: `${env.baseApiUrl}/im/admin/funnel/:funnelId/associate`,
});

export const getMultichatFunnelApi = getCreator(endpoints.GET_MULTICHAT_FUNNEL);

export const getMultichatFunnelsApi = getCreator(
  endpoints.GET_MULTICHAT_FUNNELS
);

export const createMultichatFunnelApi = postCreator(
  endpoints.CREATE_MULTICHAT_FUNNEL
);

export const editMultichatFunnelApi = putCreator(
  endpoints.EDIT_MULTICHAT_FUNNEL
);

export const getMultichatFunnelStagesApi = getCreator(
  endpoints.GET_MULTICHAT_FUNNEL_STAGES
);

export const createMultichatFunnelStageApi = postCreator(
  endpoints.CREATE_MULTICHAT_FUNNEL_STAGE
);

export const editMultichatFunnelStageApi = putCreator(
  endpoints.EDIT_MULTICHAT_FUNNEL_STAGE
);

export const setMultichatFunnelMainLaneApi = postCreator(
  endpoints.SET_MULTICHAT_FUNNEL_MAIN_LANE
);

export const getLaneConversationsApi = getCreator(
  endpoints.GET_LANE_CONVERSATIONS
);

export const sortFunnelConversationsApi = putCreator(
  endpoints.SORT_FUNNEL_CONVERSATIONS
);

export const addConversationToFunnelApi = postCreator(
  endpoints.ADD_CONVERSATION_TO_FUNNEL
);

export const deleteMultichatFunnelLaneApi = deleteCreator(
  endpoints.DELETE_MULTICHAT_FUNNEL_LANE
);
